import React, { useState, useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Container, Form, Row, Col } from "react-bootstrap";
import SvgIcon from '@material-ui/core/SvgIcon';
import CreditCardDollar from '../icons/creditcard-dollar.svg';
import { TextInput, SelectInput, DateInput } from "../../../Helpers/Inputs/index";
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles';
import Warning from '../icons/warning.svg';
import LightBulb from '../icons/light-bulb.svg';
import CalenderSchedule from '../icons/calender-schedule.svg';
import GetStateListForAflac from '../Helpers/StateListForAflac';
import months, { montListWithMonthNuber } from "../../../Helpers/Lists/Months";
import moment from "moment";
import { InputMaskSSN } from "../../../Helpers/Formatters";
import { object, string, mixed, number as yupnumber,customValidators } from '../../../Helpers/Validators/customValidators';
import GenerateUniqueSSN from '../../../Helpers/Prefill/GenerateUniqueSSN';
import CircularProgress from '@material-ui/core/CircularProgress';
import BackNext from '../../Common/SubComponents/BackNext';
const useStyles = makeStyles(theme => ({
    tipBox: {
        backgroundColor: alpha(theme.palette.primary.main, .1),
        borderRadius: '10px',
        padding: "12px"
    },
    insideTitle: {
        color: theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: 600,
    },
    insideIcon: {
        height: "24px",
        width: "24px",
        marginBottom: "-7px",
        marginRight: "-8px",
    },
    insideText: {
        fontSize: "14px",
    }
}));

export default function PaymentInfo(props) {

    const classes = useStyles();

    const getnameOnAccountOptions = () => {
        let list = []
        var form = { ...props.fullFormState };
        const insuredPersonFullName = `${form.steps.personalInfo.lastName} ${form.steps.personalInfo.firstName} ${form.steps.personalInfo.middleInitial}`;
        const spouseFullName = `${form.steps.spouseInfo.lastName} ${form.steps.spouseInfo.firstName} ${form.steps.spouseInfo.middleInitial}`;
        const showSpouseScreenPlan = ['namedSpousePremium', 'twoParentFamilyPremium'];
        list.push(
            { value: "Name of Proposed Insured", label: insuredPersonFullName },
        );
        if (form.steps.quoter.plan && showSpouseScreenPlan.includes(form.steps.quoter.plan)) {
            list.push({ value: "Name of Spouse", label: spouseFullName })
        }
        list.push({ value: "New Individual", label: "New Individual" });
        return list;
    }

    const getPaymentMethodOptions = () => {
        return (
            [
                { value: "Bank Draft", label: "Bank Draft" },
                { value: "Credit Card", label: "Credit Card" },
            ]
        )
    }


    const getPaymentModeOptions = () => {
        return (
            [
                { value: "Monthly", label: "Monthly" },
                { value: "Quaterly", label: "Quaterly" },
                { value: "Semiannual", label: "Semiannual" },
                { value: "Annual", label: "Annual" },
            ]
        )
    }

    const getExpirationYear = () => {
        const getCurrentYear = new Date().getFullYear();
        let data = [];
        for (let i = getCurrentYear; i <= getCurrentYear + 10; i++) {
            data.push({ value: i, label: i });
        }
        return data;
    }

    const getAccountTypeOptions = () => {
        return (
            [
                { value: "Checking", label: "Checking" },
                { value: "Savings", label: "Savings" },
            ]
        )
    }
    const [isCardExpired, setIsCardExpired] = useState(false);
    const [dateCalenderOpen, setDateCalenderOpen] = useState(false);
    const [routingLoading, setRoutingLoading] = useState('');
    const [hasRoutingNumberError, setHasRoutingNumberError] = useState(false);
    const routingErrorMessage = useRef();

    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: PaymentInfo.ValidationSchema(),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    const checkIsCardExpired = () => {
        const today = new Date();
        if (today.getFullYear() == props.formState.cardExpirationYear && props.formState.cardExpirationMonth !== "") {
            const month = montListWithMonthNuber.find((x => x.label === props.formState.cardExpirationMonth)).value;
            if (month <= today.getMonth()) {
                setIsCardExpired(true);
            }
            else
                setIsCardExpired(false);
        }
        else {
            setIsCardExpired(false);
        }
    }
    useEffect(() => {
        checkIsCardExpired();
    }, [props.formState.cardExpirationYear]);

    useEffect(() => {
        checkIsCardExpired();
    }, [props.formState.cardExpirationMonth]);
    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        if (props.formState.nameOnAccount === "Name of Proposed Insured") {
            handlePayerChange("nameOnAccount", props.formState.nameOnAccount)
        }
    }, []);

    useEffect(() => {
        register({ name: 'nameOnAccount' });
        setValue('nameOnAccount', props.formState.nameOnAccount);
        register({ name: 'dependentChild' });
        setValue('dependentChild', props.formState.dependentChild);

        register({ name: 'firstDeduction' });
        setValue('firstDeduction', props.formState.firstDeduction);

        register({ name: 'accountHolderFirstName' });
        setValue('accountHolderFirstName', props.formState.accountHolderFirstName);

        register({ name: 'accountHolderMiddleInitial' });
        setValue('accountHolderMiddleInitial', props.formState.accountHolderMiddleInitial);

        register({ name: 'accountHolderLastName' });
        setValue('accountHolderLastName', props.formState.accountHolderLastName);

        register({ name: 'accountHolderStreet' });
        setValue('accountHolderStreet', props.formState.accountHolderStreet);

        register({ name: 'accountHolderCity' });
        setValue('accountHolderCity', props.formState.accountHolderCity);

        register({ name: 'accountHolderState' });
        setValue('accountHolderState', props.formState.accountHolderState);

        register({ name: 'accountHolderZip' });
        setValue('accountHolderZip', props.formState.accountHolderZip);

        register({ name: 'accountHolderEmail' });
        setValue('accountHolderEmail', props.formState.accountHolderEmail);

        register({ name: 'paymentMethod' });
        setValue('paymentMethod', props.formState.paymentMethod);

        register({ name: 'paymentMode' });
        setValue('paymentMode', props.formState.paymentMode);

        register({ name: 'cardNumber' });
        setValue('cardNumber', props.formState.cardNumber);

        register({ name: 'cardExpirationMonth' });
        setValue('cardExpirationMonth', props.formState.cardExpirationMonth);

        register({ name: 'cardExpirationYear' });
        setValue('cardExpirationYear', props.formState.cardExpirationYear);

        register({ name: 'routingNumber' });
        setValue('routingNumber', props.formState.routingNumber);

        register({ name: 'accountNumber' });
        setValue('accountNumber', props.formState.accountNumber);

        register({ name: 'accountType' });
        setValue('accountType', props.formState.accountType);

        register({ name: 'draftPreferenceDay' });
        setValue('draftPreferenceDay', props.formState.draftPreferenceDay);

        register({ name: 'draftPreferenceMonth' });
        setValue('draftPreferenceMonth', props.formState.draftPreferenceMonth);
    }, [register])

    const handlePayerChange = (field, value) => {
        var form = { ...props.fullFormState };
        var firstName, middleName, lastName, street, city, state, zip, email;
        if (value === "Name of Proposed Insured") {
            if (form.steps.personalInfo) {
                firstName = form.steps.personalInfo.firstName;
                middleName = form.steps.personalInfo.middleInitial;
                lastName = form.steps.personalInfo.lastName;
                street = form.steps.personalInfo.street;
                city = form.steps.personalInfo.city;
                state = form.steps.personalInfo.state;
                zip = form.steps.personalInfo.zip;
                email = form.steps.personalInfo.emailAddress;
            }
        }

        if (value === "Name of Spouse") {
            if (form.steps.spouseInfo) {
                firstName = form.steps.spouseInfo.firstName;
                middleName = form.steps.spouseInfo.middleInitial;
                lastName = form.steps.spouseInfo.lastName;
                street = "";
                city = "";
                state = "";
                zip = "";
            }
        }
        form.steps.paymentInfo.accountHolderFirstName = firstName ? firstName : "";
        form.steps.paymentInfo.accountHolderMiddleInitial = middleName ? middleName : "";
        form.steps.paymentInfo.accountHolderLastName = lastName ? lastName : "";
        form.steps.paymentInfo.accountHolderStreet = street ? street : "";
        form.steps.paymentInfo.accountHolderCity = city ? city : "";
        form.steps.paymentInfo.accountHolderState = state ? state : "";
        form.steps.paymentInfo.accountHolderZip = zip ? zip : "";
        form.steps.paymentInfo.nameOnAccount = value;
        form.steps.paymentInfo.accountHolderEmail = email ? email : "";
        setValue('nameOnAccount', value);
        setValue('accountHolderFirstName', firstName);
        setValue('accountHolderMiddleInitial', middleName);
        setValue('accountHolderLastName', lastName);
        setValue('accountHolderStreet', street);
        setValue('accountHolderCity', city);
        setValue('accountHolderState', state);
        setValue('accountHolderZip', zip);
        setValue('accountHolderEmail', email);
        props.onMultiFieldChange(form);

    }
    useEffect(() => {
        if (props.formState.firstDeduction) {
            handleValueChange('draftPreferenceMonth', moment(props.formState.firstDeduction).month());
            handleValueChange('draftPreferenceDay', moment(props.formState.firstDeduction).date());
        }
    }, [props.formState.firstDeduction])

    const datesToDisabled = (date) => {
        return date.date() === 29 || date.date() === 30 || date.date() === 31;
    }

    const routingNumberCheck = () => {
        setHasRoutingNumberError(false);

        const regex = RegExp(/^[0-9]{9}$/);

        const isValidRouting = regex.test(props.formState.routingNumber);

        if (isValidRouting) {
            setRoutingLoading(<CircularProgress size={25} thickness={4.5} />);

            fetch(`${covrServicesUrl}/api/Americo/GetBankNameFromRoutingNumber?routingNumber=${props.formState.routingNumber}`)
                .then(res => res.json())
                .then(json => {
                    if (json.success) {
                        setRoutingLoading('');
                    }
                    else if (!json.success) {
                        setHasRoutingNumberError(true);
                        setRoutingLoading('');
                    }
                })
        }
    }

    let debounce = null;
    useEffect(() => {
        let isSubscribed = true;
        if (debounce) {
            clearTimeout(debounce);
        }

        debounce = setTimeout(() => routingNumberCheck(() => isSubscribed), 1000);
        return () => {
            clearTimeout(debounce);
            isSubscribed = false;
        }
    }, [props.formState.routingNumber])

    const onSubmit = () => {

        if (hasRoutingNumberError && props.formState.paymentMethod == "Bank Draft") {
            window.scrollTo(0, routingErrorMessage.current.offsetTop);
            return;
        }
        if (props.formState.paymentMethod == "Credit Card" && isCardExpired)
            return;

        props.onNext();
    };
    const currentMonth = moment().startOf("month").format('MMMM');
    const currentYear = new Date().getFullYear();
    return (

        <Container fluid className='border-class payment-info'>


            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="justify-content-center pt-3">
                    <Col lg={5}>
                        <div className="text-center mb-2 pt-4"><SvgIcon component={CreditCardDollar} className="small-icons" color="primary" fontSize="large" /></div>
                        <div className="text-center mb-3 form-title">Payment Information</div>

                        <Form.Group>
                            <p className="section-title">Who will be paying for this coverage?</p>
                            <SelectInput
                                name="nameOnAccount"
                                id="nameOnAccount"
                                value={props.formState.nameOnAccount}
                                onChange={e => handlePayerChange('nameOnAccount', e.target.value)}
                                label="Insurance Payor"
                                selectOptions={getnameOnAccountOptions()}
                                errors={errors && errors.nameOnAccount}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group>
                            <p className="section-title">Please choose when you would like to make your first payment. This will also be your coverage effective date.</p>
                            <DateInput
                                calenderOpen={dateCalenderOpen}
                                setCalenderOpen={setDateCalenderOpen}
                                autoOk
                                variant="inline"
                                disableToolbar
                                inputVariant="filled"
                                name="firstDeduction"
                                id="firstDeduction"
                                label="First deduction"
                                format="MMMM D, YYYY"
                                value={props.formState.firstDeduction}
                                onChange={value => handleValueChange('firstDeduction', value)}
                                minDate={moment().add(1, 'days')}
                                maxDate={moment().add(1, 'M')}
                                shouldDisableDate={datesToDisabled}
                                inputRef={register}
                                fullWidth
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                keyboardIcon={<SvgIcon component={CalenderSchedule} />}
                                errors={errors && errors.firstDeduction}
                                InputProps={{ readOnly: true }}
                                disablePast
                            />
                        </Form.Group>

                        <Row>
                            <p className={`${classes.tipBox} mx-3`}>
                                <b className={classes.insideTitle}>
                                    <SvgIcon component={Warning} fontSize="large" className={classes.insideIcon} />
                                    Important:{' '}
                                </b>
                                <b className={classes.insideText}>Your policy will become effective upon the draft of your first premium payment. Your payment will then be drafted on this date each month.</b>
                            </p>
                        </Row>

                        {props.formState.nameOnAccount === "New Individual" &&
                            <Fragment>
                                <p className="section-title"><b>Payor Information</b></p>
                                <Form.Group>
                                    <TextInput
                                        name="accountHolderFirstName"
                                        id="accountHolderFirstName"
                                        label="First Name"
                                        value={props.formState.accountHolderFirstName}
                                        onChange={e => handleValueChange('accountHolderFirstName', e.target.value)}
                                        errors={errors.accountHolderFirstName}
                                        inputRef={register}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <TextInput
                                        name="accountHolderMiddleInitial"
                                        id="accountHolderMiddleInitial"
                                        label="Middle Initial"
                                        value={props.formState.accountHolderMiddleInitial}
                                        onChange={e => handleValueChange('accountHolderMiddleInitial', e.target.value)}
                                        errors={errors.accountHolderMiddleInitial}
                                        inputRef={register}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <TextInput
                                        name="accountHolderLastName"
                                        id="accountHolderLastName"
                                        label="Last Name"
                                        value={props.formState.accountHolderLastName}
                                        onChange={e => handleValueChange('accountHolderLastName', e.target.value)}
                                        errors={errors.accountHolderLastName}
                                        inputRef={register}
                                    />
                                </Form.Group>
                            </Fragment>
                        }

                        {props.formState.nameOnAccount && props.formState.nameOnAccount !== "Name of Proposed Insured" &&
                            <Fragment>
                                <p className="section-title"><b>Street Address</b></p>
                                <Form.Group>
                                    <TextInput
                                        name="accountHolderStreet"
                                        id="accountHolderStreet"
                                        label="Street Address"
                                        value={props.formState.accountHolderStreet}
                                        onChange={e => handleValueChange('accountHolderStreet', e.target.value)}
                                        errors={errors.accountHolderStreet}
                                        inputRef={register}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <TextInput
                                        name="accountHolderCity"
                                        id="accountHolderCity"
                                        label="City"
                                        value={props.formState.accountHolderCity}
                                        onChange={e => handleValueChange('accountHolderCity', e.target.value)}
                                        errors={errors.accountHolderCity}
                                        inputRef={register}
                                    />
                                </Form.Group>

                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <SelectInput
                                                name="accountHolderState"
                                                id="accountHolderState"
                                                value={props.formState.accountHolderState}
                                                onChange={(e) => handleValueChange('accountHolderState', e.target.value)}
                                                label="State"
                                                selectOptions={GetStateListForAflac()}
                                                errors={errors && errors.accountHolderState}
                                                inputRef={register}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <TextInput
                                                name="accountHolderZip"
                                                id="accountHolderZip"
                                                label="Zip"
                                                value={props.formState.accountHolderZip}
                                                onChange={e => handleValueChange('accountHolderZip', e.target.value)}
                                                errors={errors.accountHolderZip}
                                                inputRef={register}
                                                inputProps={{
                                                    maxLength: 5,
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group>
                                    <TextInput
                                        name="accountHolderEmail"
                                        id="accountHolderEmail"
                                        label="Email address"
                                        value={props.formState.accountHolderEmail}
                                        onChange={e => handleValueChange('accountHolderEmail', e.target.value)}
                                        errors={errors.accountHolderEmail}
                                        inputRef={register}
                                    />
                                </Form.Group>

                            </Fragment>
                        }

                        <p className="section-title"><b>Payment Account Details</b></p>

                        <Form.Group>
                            <SelectInput
                                name="paymentMethod"
                                id="paymentMethod"
                                value={props.formState.paymentMethod}
                                onChange={(e) => handleValueChange('paymentMethod', e.target.value)}
                                label="Payment Method"
                                selectOptions={getPaymentMethodOptions()}
                                errors={errors && errors.paymentMethod}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group hidden>
                            <SelectInput
                                name="paymentMode"
                                id="paymentMode"
                                value={props.formState.paymentMode ? props.formState.paymentMode : "Monthly"}
                                onChange={(e) => handleValueChange('paymentMode', e.target.value)}
                                label="Payment Mode"
                                selectOptions={getPaymentModeOptions()}
                                errors={errors && errors.paymentMode}
                                inputRef={register}
                            />
                        </Form.Group>

                        {props.formState.paymentMethod === "Credit Card" &&
                            <Fragment>
                                <Form.Group>
                                    <TextInput
                                        name="cardNumber"
                                        id="cardNumber"
                                        label="Card Number"
                                        value={props.formState.cardNumber}
                                        onChange={e => handleValueChange('cardNumber', e.target.value)}
                                        errors={errors.cardNumber}
                                        inputRef={register}
                                        inputProps={{
                                            maxLength: 16,
                                        }}
                                    />
                                </Form.Group>

                                <Row>
                                    <Col sm={6}>
                                        <Form.Group>
                                            <SelectInput
                                                name="cardExpirationMonth"
                                                id="cardExpirationMonth"
                                                value={props.formState.cardExpirationMonth}
                                                onChange={(e) => handleValueChange('cardExpirationMonth', e.target.value)}
                                                label="Exp Month"
                                                selectOptions={months()}
                                                errors={errors && errors.cardExpirationMonth}
                                                inputRef={register}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Group>
                                            <SelectInput
                                                name="cardExpirationYear"
                                                id="cardExpirationYear"
                                                value={props.formState.cardExpirationYear}
                                                onChange={(e) => handleValueChange('cardExpirationYear', e.target.value)}
                                                label="Exp Year"
                                                selectOptions={getExpirationYear()}
                                                errors={errors && errors.cardExpirationYear}
                                                inputRef={register}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} className="text-center mb-3">
                                        {isCardExpired && <span className="text-danger">Your card is expired. Please input a valid card expiring after {currentMonth} {currentYear}</span>}
                                    </Col>
                                </Row>
                            </Fragment>
                        }

                        {props.formState.paymentMethod === "Bank Draft" &&
                            <Fragment>
                                <Form.Group>
                                    <TextInput
                                        name="routingNumber"
                                        id="routingNumber"
                                        label="Routing Number"
                                        value={props.formState.routingNumber}
                                        onChange={e => handleValueChange('routingNumber', e.target.value)}
                                        errors={errors.routingNumber}
                                        inputRef={register}
                                        inputProps={{
                                            maxLength: 9,
                                        }}
                                        InputProps={{
                                            endAdornment: routingLoading
                                        }}
                                    />
                                </Form.Group>

                                {
                                    hasRoutingNumberError && (
                                        <div ref={routingErrorMessage} className="text-danger text-center mb-3">Unable to verify routing number.</div>)
                                }

                                <Form.Group>
                                    <TextInput
                                        name="accountNumber"
                                        id="accountNumber"
                                        label="Account Number"
                                        value={props.formState.accountNumber}
                                        onChange={e => handleValueChange('accountNumber', e.target.value)}
                                        errors={errors.accountNumber}
                                        inputRef={register}
                                        inputProps={{
                                            maxLength: 17,
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <SelectInput
                                        name="accountType"
                                        id="accountType"
                                        value={props.formState.accountType}
                                        onChange={(e) => handleValueChange('accountType', e.target.value)}
                                        label="Account Type"
                                        selectOptions={getAccountTypeOptions()}
                                        errors={errors && errors.accountType}
                                        inputRef={register}
                                    />
                                </Form.Group>
                            </Fragment>
                        }

                        <Row>
                            <p className={`${classes.tipBox} mx-3`}>
                                <b className={classes.insideTitle}>
                                    <SvgIcon component={LightBulb} fontSize="large" className={classes.insideIcon} />
                                    Insider Tip:{' '}
                                </b>
                                <b className={classes.insideText}>This site is completely secure though 256bit TLS encryption. All necessary precautions and technologies have been put in place to protect our customers and their personal information.</b>
                            </p>
                        </Row>

                        <Form.Group>
                            <TextInput
                                name="socialSecurityNumber"
                                id="socialSecurityNumber"
                                label="Social Security Number"
                                value={props.formState.socialSecurityNumber}
                                onChange={e => handleValueChange('socialSecurityNumber', e.target.value)}
                                errors={errors.socialSecurityNumber}
                                inputRef={register}
                                InputProps={{
                                    inputComponent: InputMaskSSN,
                                }}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <div className='backnext-wrapper'>
                    <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} nextDisabled={routingLoading} />
                </div>
            </Form>
        </Container >
    );
}

PaymentInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

PaymentInfo.ValidationSchema = () => {
    return object().shape({
        nameOnAccount: string().required('Account Holder is required.'),
        dependentChild: yupnumber().when('selectPrimary', {
            is: "Dependent Child",
            then: yupnumber().required("Dependent child is required."),
            otherwise: yupnumber().notRequired()
        }),
        firstDeduction: mixed().required("First Deduction date is required.").test({
            message: "Invalid Date",
            test: (value) => moment(value).isValid()
        }),
        accountHolderFirstName: string().when('nameOnAccount', {
            is: "New Individual",
            then: string().required("First Name is required."),
            otherwise: string().notRequired()
        }),
        accountHolderMiddleInitial: string().when('nameOnAccount', {
            is: "New Individual",
            then: customValidators.string().isValidNameWithFiftyChar('Middle Initials is required', false),
            otherwise: string().notRequired()
        }),
        accountHolderLastName: string().when('nameOnAccount', {
            is: "New Individual",
            then: string().required("Last Name is required."),
            otherwise: string().notRequired()
        }),
        accountHolderStreet: string().when('nameOnAccount', {
            is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
            then: string().required("Street is required."),
            otherwise: string().notRequired()
        }),
        accountHolderCity: string().when('nameOnAccount', {
            is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
            then: string().required("City is required."),
            otherwise: string().notRequired()
        }),
        accountHolderState: string().when('nameOnAccount', {
            is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
            then: string().required("State is required."),
            otherwise: string().notRequired()
        }),
        accountHolderZip: string().when('nameOnAccount', {
            is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
            then: string().required("Zip is required."),
            otherwise: string().notRequired()
        }),
        accountHolderEmail: string().when('nameOnAccount', {
            is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
            then: string()
                .email('Email address must be valid.')
                .notRequired(),
            otherwise: string().notRequired()
        }),
        paymentMethod: string().required("Payment Method is required."),
        cardNumber: string().when('paymentMethod', {
            is: "Credit Card",
            then: string()
                .isValidCreditCardType('Aflac will only accept Visa, Mastercard and American Express. Please submit using a valid card type.', 'cardNumber'),
            otherwise: string().notRequired()
        }),
        cardExpirationMonth: string().when('paymentMethod', {
            is: "Credit Card",
            then: string().required("Card Expiration Month is required."),
            otherwise: string().notRequired()
        }),
        cardExpirationYear: string().when('paymentMethod', {
            is: "Credit Card",
            then: string().required("Card Expiration Year is required."),
            otherwise: string().notRequired()
        }),
        routingNumber: string().when('paymentMethod', {
            is: "Bank Draft",
            then: string().required('Routing Number is required.')
                .matches(/^[0-9]{9}$/, 'The routing number must be 9 digits in length.'),
            otherwise: string().notRequired()
        }),
        accountNumber: string().when('paymentMethod', {
            is: "Bank Draft",
            then: string().required('Account Number is required.')
                .matches(/^[0-9]{4,17}$/, 'The account number must be between 4 and 17 digits in length.'),
            otherwise: string().notRequired()
        }),
        accountType: string().when('paymentMethod', {
            is: "Bank Draft",
            then: string().required("Account Type is required."),
            otherwise: string().notRequired()
        }),
        socialSecurityNumber: string()
            .required('Social Security Number is required.')
            .matches(/\d{3}-\d{2}-\d{4}/, 'Social Security Number must be formatted as "123-45-6789".'),
    })
};

PaymentInfo.DefaultFormState = (prefill = false) => {
    return {
        nameOnAccount: 'Name of Proposed Insured',
        dependentChild: 1,
        firstDeduction: null,
        accountHolderFirstName: prefill ? 'Props' : '',
        accountHolderMiddleInitial: prefill ? 'N' : '',
        accountHolderLastName: prefill ? "Sured" : '',
        accountHolderStreet: prefill ? "2020 Covr St" : '',
        accountHolderCity: prefill ? "Boise" : '',
        accountHolderState: prefill ? "CA" : '',
        accountHolderZip: prefill ? "83702" : '',
        accountHolderEmail: prefill ? 'user@address.com' : '',
        paymentMethod: prefill ? 'Credit Card' : '',
        paymentMode: 'Monthly',
        cardNumber: prefill ? '12345678910' : '',
        cardExpirationMonth: prefill ? 'january' : '',
        cardExpirationYear: prefill ? '2023' : '',
        routingNumber: prefill ? '081218879' : '',
        accountNumber: prefill ? '11111111112' : '',
        accountType: prefill ? 'Savings' : '',
        socialSecurityNumber: prefill ? GenerateUniqueSSN('444') : "",
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/PaymentInfo.js